import { render } from "./singleRental.vue?vue&type=template&id=2f82f3c4&scoped=true"
import script from "./singleRental.vue?vue&type=script&lang=js"
export * from "./singleRental.vue?vue&type=script&lang=js"

import "./singleRental.vue?vue&type=style&index=0&id=2f82f3c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f82f3c4"]])

export default __exports__